import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
```
- Press **Ctrl+S** (Windows) or **Cmd+S** (Mac) to save

---

## PART 4: Install GitHub Pages package

**Step 8:**

Click on the terminal at the bottom and type:
```
